let api = process.env.REACT_APP_MKGF_MASTODON_API+'/speed-meeting'

export const createMeeting = async ({token, mastodon_id, trackingInterest}) => {
    let body = { mastodon_id, trackingInterest } 
    const headers = { 'Authorization': 'Bearer '+token, 'Content-Type': 'application/json' }
    const response = await fetch( api+'/', { method:"POST", headers, body:JSON.stringify(body) });
    
    if (!response.ok) {
        const errorText = await response.text();
        console.error('Create meeting failed:', errorText);
        throw new Error(`Create meeting failed: ${response.status} ${response.statusText}`);
    }
    
    const data = await response.json();
    return data
}

export const getAllMeetings = async ({token}) => {
    const headers = { 'Authorization': 'Bearer '+token, 'Content-Type': 'application/json' }
    const response = await fetch( api+'/all', { method:"GET", headers });
    
    if (!response.ok) {
        const errorText = await response.text();
        console.error('Get meetings failed:', errorText);
        throw new Error(`Get meetings failed: ${response.status} ${response.statusText}`);
    }
    
    const data = await response.json();
    return data
}

export const rsvpMeeting = async ({token, title, start_time, user_id, avatar}) => {
    const headers = { 'Authorization': 'Bearer '+token, 'Content-Type': 'application/json' }

    // TODO: Replace with correct body format
    const body = { 
        title, 
        start_time, 
        user_id, 
        avatar
    };
    
    const response = await fetch( api+'/rsvp', { 
        method:"POST", 
        headers, 
        body:JSON.stringify(body) 
    });
    
    if (!response.ok) {
        const errorText = await response.text();
        console.error('RSVP failed:', errorText);
        throw new Error(`RSVP failed: ${response.status} ${response.statusText} - ${errorText}`);
    }
    
    const data = await response.json();
    console.log('RSVP successful');
    return data;
}

// Test function to check API connectivity
export const testApiConnection = async ({token}) => {
    const headers = { 'Authorization': 'Bearer '+token, 'Content-Type': 'application/json' }
    try {
        const response = await fetch( api+'/all', { method:"GET", headers });
        return { success: response.ok, status: response.status, statusText: response.statusText };
    } catch (error) {
        return { success: false, error: error.message };
    }
}